module.exports = __webpack_public_path__ + "static/media/coffee.6de64817.svg";